import { render } from "./subscribedcompanies-modal.vue?vue&type=template&id=70dc4003"
import script from "./subscribedcompanies-modal.vue?vue&type=script&lang=js"
export * from "./subscribedcompanies-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__